import React from 'react';
import { bool, func, node, oneOf, string } from 'prop-types';
import classNames from 'classnames';

import css from './TopBanner.module.css';

/**
 * TopBanner is a component for displaying important messages at the top of the page.
 * It supports different types: info, warning, error, success
 * Can be dismissible or non-dismissible
 */
const TopBanner = props => {
  const {
    className,
    rootClassName,
    type,
    dismissible,
    onDismiss,
    children,
    testId,
  } = props;

  const classes = classNames(
    rootClassName || css.root,
    {
      [css.info]: type === 'info',
      [css.warning]: type === 'warning',
      [css.error]: type === 'error',
      [css.success]: type === 'success',
      [css.dismissible]: dismissible,
    },
    className
  );

  return (
    <div className={classes} data-testid={testId}>
      <div className={css.content}>
        {children}
      </div>
      {dismissible && onDismiss && (
        <button
          className={css.dismissButton}
          onClick={onDismiss}
          aria-label="Sulje ilmoitus"
          type="button"
        >
          ×
        </button>
      )}
    </div>
  );
};

TopBanner.defaultProps = {
  className: null,
  rootClassName: null,
  type: 'info',
  dismissible: false,
  onDismiss: null,
  testId: 'TopBanner',
};

TopBanner.propTypes = {
  className: string,
  rootClassName: string,
  type: oneOf(['info', 'warning', 'error', 'success']),
  dismissible: bool,
  onDismiss: func,
  children: node.isRequired,
  testId: string,
};

export default TopBanner;
